module.exports = __webpack_public_path__ + "041a7d79e5e4e769ba72e3c4cab3bff0.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img-layout/news1-thumb.jpg
 ** module id = 513
 ** module chunks = 1
 **/